var ps = Object.defineProperty;
var fs = (e, t, s) => t in e ? ps(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var c = (e, t, s) => fs(e, typeof t != "symbol" ? t + "" : t, s);
var ds = Object.defineProperty, ms = (e, t, s) => t in e ? ds(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, ee = (e, t, s) => ms(e, typeof t != "symbol" ? t + "" : t, s), d = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(d || {});
class gs {
  constructor() {
    ee(this, "idNodeMap", /* @__PURE__ */ new Map()), ee(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    var s;
    return t ? ((s = this.getMeta(t)) == null ? void 0 : s.id) ?? -1 : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const s = this.getId(t);
    this.idNodeMap.delete(s), t.childNodes && t.childNodes.forEach(
      (r) => this.removeNodeFromMap(r)
    );
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, s) {
    const r = s.id;
    this.idNodeMap.set(r, t), this.nodeMetaMap.set(t, s);
  }
  replace(t, s) {
    const r = this.getNode(t);
    if (r) {
      const i = this.nodeMetaMap.get(r);
      i && this.nodeMetaMap.set(s, i);
    }
    this.idNodeMap.set(t, s);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function ws() {
  return new gs();
}
function ys(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function bs(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var s = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    s.prototype = t.prototype;
  } else s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(s, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), s;
}
var jt = { exports: {} }, f = String, Ee = function() {
  return { isColorSupported: !1, reset: f, bold: f, dim: f, italic: f, underline: f, inverse: f, hidden: f, strikethrough: f, black: f, red: f, green: f, yellow: f, blue: f, magenta: f, cyan: f, white: f, gray: f, bgBlack: f, bgRed: f, bgGreen: f, bgYellow: f, bgBlue: f, bgMagenta: f, bgCyan: f, bgWhite: f, blackBright: f, redBright: f, greenBright: f, yellowBright: f, blueBright: f, magentaBright: f, cyanBright: f, whiteBright: f, bgBlackBright: f, bgRedBright: f, bgGreenBright: f, bgYellowBright: f, bgBlueBright: f, bgMagentaBright: f, bgCyanBright: f, bgWhiteBright: f };
};
jt.exports = Ee();
jt.exports.createColors = Ee;
var Es = jt.exports;
const xs = {}, Cs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xs
}, Symbol.toStringTag, { value: "Module" })), S = /* @__PURE__ */ bs(Cs);
let se = Es, re = S, Ct = class xe extends Error {
  constructor(t, s, r, i, n, a) {
    super(t), this.name = "CssSyntaxError", this.reason = t, n && (this.file = n), i && (this.source = i), a && (this.plugin = a), typeof s < "u" && typeof r < "u" && (typeof s == "number" ? (this.line = s, this.column = r) : (this.line = s.line, this.column = s.column, this.endLine = r.line, this.endColumn = r.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, xe);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(t) {
    if (!this.source) return "";
    let s = this.source;
    t == null && (t = se.isColorSupported);
    let r = (u) => u, i = (u) => u, n = (u) => u;
    if (t) {
      let { bold: u, gray: m, red: w } = se.createColors(!0);
      i = (E) => u(w(E)), r = (E) => m(E), re && (n = (E) => re(E));
    }
    let a = s.split(/\r?\n/), o = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, a.length), p = String(l).length;
    return a.slice(o, l).map((u, m) => {
      let w = o + 1 + m, E = " " + (" " + w).slice(-p) + " | ";
      if (w === this.line) {
        if (u.length > 160) {
          let h = 20, v = Math.max(0, this.column - h), N = Math.max(
            this.column + h,
            this.endColumn + h
          ), x = u.slice(v, N), b = r(E.replace(/\d/g, " ")) + u.slice(0, Math.min(this.column - 1, h - 1)).replace(/[^\t]/g, " ");
          return i(">") + r(E) + n(x) + `
 ` + b + i("^");
        }
        let D = r(E.replace(/\d/g, " ")) + u.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return i(">") + r(E) + n(u) + `
 ` + D + i("^");
      }
      return " " + r(E) + n(u);
    }).join(`
`);
  }
  toString() {
    let t = this.showSourceCode();
    return t && (t = `

` + t + `
`), this.name + ": " + this.message + t;
  }
};
var zt = Ct;
Ct.default = Ct;
const ie = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function Rs(e) {
  return e[0].toUpperCase() + e.slice(1);
}
let Rt = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let s = "@" + e.name, r = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName < "u" ? s += e.raws.afterName : r && (s += " "), e.nodes)
      this.block(e, s + r);
    else {
      let i = (e.raws.between || "") + (t ? ";" : "");
      this.builder(s + r + i, e);
    }
  }
  beforeAfter(e, t) {
    let s;
    e.type === "decl" ? s = this.raw(e, null, "beforeDecl") : e.type === "comment" ? s = this.raw(e, null, "beforeComment") : t === "before" ? s = this.raw(e, null, "beforeRule") : s = this.raw(e, null, "beforeClose");
    let r = e.parent, i = 0;
    for (; r && r.type !== "root"; )
      i += 1, r = r.parent;
    if (s.includes(`
`)) {
      let n = this.raw(e, null, "indent");
      if (n.length)
        for (let a = 0; a < i; a++) s += n;
    }
    return s;
  }
  block(e, t) {
    let s = this.raw(e, "between", "beforeOpen");
    this.builder(t + s + "{", e, "start");
    let r;
    e.nodes && e.nodes.length ? (this.body(e), r = this.raw(e, "after")) : r = this.raw(e, "after", "emptyBody"), r && this.builder(r), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let s = this.raw(e, "semicolon");
    for (let r = 0; r < e.nodes.length; r++) {
      let i = e.nodes[r], n = this.raw(i, "before");
      n && this.builder(n), this.stringify(i, t !== r || s);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), s = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + s + "*/", e);
  }
  decl(e, t) {
    let s = this.raw(e, "between", "colon"), r = e.prop + s + this.rawValue(e, "value");
    e.important && (r += e.raws.important || " !important"), t && (r += ";"), this.builder(r, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, s) {
    let r;
    if (s || (s = t), t && (r = e.raws[t], typeof r < "u"))
      return r;
    let i = e.parent;
    if (s === "before" && (!i || i.type === "root" && i.first === e || i && i.type === "document"))
      return "";
    if (!i) return ie[s];
    let n = e.root();
    if (n.rawCache || (n.rawCache = {}), typeof n.rawCache[s] < "u")
      return n.rawCache[s];
    if (s === "before" || s === "after")
      return this.beforeAfter(e, s);
    {
      let a = "raw" + Rs(s);
      this[a] ? r = this[a](n, e) : n.walk((o) => {
        if (r = o.raws[t], typeof r < "u") return !1;
      });
    }
    return typeof r > "u" && (r = ie[s]), n.rawCache[s] = r, r;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && s.nodes.length > 0 && typeof s.raws.after < "u")
        return t = s.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let s;
    return e.walkComments((r) => {
      if (typeof r.raws.before < "u")
        return s = r.raws.before, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
    }), typeof s > "u" ? s = this.raw(t, null, "beforeDecl") : s && (s = s.replace(/\S/g, "")), s;
  }
  rawBeforeDecl(e, t) {
    let s;
    return e.walkDecls((r) => {
      if (typeof r.raws.before < "u")
        return s = r.raws.before, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
    }), typeof s > "u" ? s = this.raw(t, null, "beforeRule") : s && (s = s.replace(/\S/g, "")), s;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((s) => {
      if (s.type !== "decl" && (t = s.raws.between, typeof t < "u"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && (s.parent !== e || e.first !== s) && typeof s.raws.before < "u")
        return t = s.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((s) => {
      if (typeof s.raws.between < "u")
        return t = s.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && s.nodes.length === 0 && (t = s.raws.after, typeof t < "u"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((s) => {
      let r = s.parent;
      if (r && r !== e && r.parent && r.parent === e && typeof s.raws.before < "u") {
        let i = s.raws.before.split(`
`);
        return t = i[i.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && s.nodes.length && s.last.type === "decl" && (t = s.raws.semicolon, typeof t < "u"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let s = e[t], r = e.raws[t];
    return r && r.value === s ? r.raw : s;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var Ce = Rt;
Rt.default = Rt;
let Ns = Ce;
function Nt(e, t) {
  new Ns(t).stringify(e);
}
var ct = Nt;
Nt.default = Nt;
var Y = {};
Y.isClean = Symbol("isClean");
Y.my = Symbol("my");
let Ss = zt, vs = Ce, Os = ct, { isClean: F, my: Ds } = Y;
function St(e, t) {
  let s = new e.constructor();
  for (let r in e) {
    if (!Object.prototype.hasOwnProperty.call(e, r) || r === "proxyCache") continue;
    let i = e[r], n = typeof i;
    r === "parent" && n === "object" ? t && (s[r] = t) : r === "source" ? s[r] = i : Array.isArray(i) ? s[r] = i.map((a) => St(a, s)) : (n === "object" && i !== null && (i = St(i)), s[r] = i);
  }
  return s;
}
function B(e, t) {
  if (t && typeof t.offset < "u")
    return t.offset;
  let s = 1, r = 1, i = 0;
  for (let n = 0; n < e.length; n++) {
    if (r === t.line && s === t.column) {
      i = n;
      break;
    }
    e[n] === `
` ? (s = 1, r += 1) : s += 1;
  }
  return i;
}
let vt = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[F] = !1, this[Ds] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let s of e[t])
          typeof s.clone == "function" ? this.append(s.clone()) : this.append(s);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = St(this);
    for (let s in e)
      t[s] = e[s];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: s, start: r } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: r.column, line: r.line },
        { column: s.column, line: s.line },
        t
      );
    }
    return new Ss(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, s) {
        return e[t] === s || (e[t] = s, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[F] = !0;
  }
  markDirty() {
    if (this[F]) {
      this[F] = !1;
      let e = this;
      for (; e = e.parent; )
        e[F] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let s = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = s.slice(
        B(s, this.source.start),
        B(s, this.source.end)
      ).indexOf(e.word);
      r !== -1 && (t = this.positionInside(r));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, s = this.source.start.line, r = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = B(r, this.source.start), n = i + e;
    for (let a = i; a < n; a++)
      r[a] === `
` ? (t = 1, s += 1) : t += 1;
    return { column: t, line: s };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, s = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let r = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = r.slice(
        B(r, this.source.start),
        B(r, this.source.end)
      ).indexOf(e.word);
      i !== -1 && (t = this.positionInside(i), s = this.positionInside(
        i + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? s = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? s = this.positionInside(e.endIndex) : e.index && (s = this.positionInside(e.index + 1));
    return (s.line < t.line || s.line === t.line && s.column <= t.column) && (s = { column: t.column + 1, line: t.line }), { end: s, start: t };
  }
  raw(e, t) {
    return new vs().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, s = !1;
      for (let r of e)
        r === this ? s = !0 : s ? (this.parent.insertAfter(t, r), t = r) : this.parent.insertBefore(t, r);
      s || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let s = {}, r = t == null;
    t = t || /* @__PURE__ */ new Map();
    let i = 0;
    for (let n in this) {
      if (!Object.prototype.hasOwnProperty.call(this, n) || n === "parent" || n === "proxyCache") continue;
      let a = this[n];
      if (Array.isArray(a))
        s[n] = a.map((o) => typeof o == "object" && o.toJSON ? o.toJSON(null, t) : o);
      else if (typeof a == "object" && a.toJSON)
        s[n] = a.toJSON(null, t);
      else if (n === "source") {
        let o = t.get(a.input);
        o == null && (o = i, t.set(a.input, i), i++), s[n] = {
          end: a.end,
          inputId: o,
          start: a.start
        };
      } else
        s[n] = a;
    }
    return r && (s.inputs = [...t.keys()].map((n) => n.toJSON())), s;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = Os) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (s) => {
      t += s;
    }), t;
  }
  warn(e, t, s) {
    let r = { node: this };
    for (let i in s) r[i] = s[i];
    return e.warn(t, r);
  }
};
var ht = vt;
vt.default = vt;
let Ms = ht, Ot = class extends Ms {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var pt = Ot;
Ot.default = Ot;
let ks = ht, Dt = class extends ks {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value < "u" && typeof e.value != "string" && (e = { ...e, value: String(e.value) }), super(e), this.type = "decl";
  }
};
var ft = Dt;
Dt.default = Dt;
let Re = pt, Ne = ft, As = ht, { isClean: Se, my: ve } = Y, $t, Oe, De, Gt;
function Me(e) {
  return e.map((t) => (t.nodes && (t.nodes = Me(t.nodes)), delete t.source, t));
}
function ke(e) {
  if (e[Se] = !1, e.proxyOf.nodes)
    for (let t of e.proxyOf.nodes)
      ke(t);
}
let k = class Ae extends As {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...t) {
    for (let s of t) {
      let r = this.normalize(s, this.last);
      for (let i of r) this.proxyOf.nodes.push(i);
    }
    return this.markDirty(), this;
  }
  cleanRaws(t) {
    if (super.cleanRaws(t), this.nodes)
      for (let s of this.nodes) s.cleanRaws(t);
  }
  each(t) {
    if (!this.proxyOf.nodes) return;
    let s = this.getIterator(), r, i;
    for (; this.indexes[s] < this.proxyOf.nodes.length && (r = this.indexes[s], i = t(this.proxyOf.nodes[r], r), i !== !1); )
      this.indexes[s] += 1;
    return delete this.indexes[s], i;
  }
  every(t) {
    return this.nodes.every(t);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let t = this.lastEach;
    return this.indexes[t] = 0, t;
  }
  getProxyProcessor() {
    return {
      get(t, s) {
        return s === "proxyOf" ? t : t[s] ? s === "each" || typeof s == "string" && s.startsWith("walk") ? (...r) => t[s](
          ...r.map((i) => typeof i == "function" ? (n, a) => i(n.toProxy(), a) : i)
        ) : s === "every" || s === "some" ? (r) => t[s](
          (i, ...n) => r(i.toProxy(), ...n)
        ) : s === "root" ? () => t.root().toProxy() : s === "nodes" ? t.nodes.map((r) => r.toProxy()) : s === "first" || s === "last" ? t[s].toProxy() : t[s] : t[s];
      },
      set(t, s, r) {
        return t[s] === r || (t[s] = r, (s === "name" || s === "params" || s === "selector") && t.markDirty()), !0;
      }
    };
  }
  index(t) {
    return typeof t == "number" ? t : (t.proxyOf && (t = t.proxyOf), this.proxyOf.nodes.indexOf(t));
  }
  insertAfter(t, s) {
    let r = this.index(t), i = this.normalize(s, this.proxyOf.nodes[r]).reverse();
    r = this.index(t);
    for (let a of i) this.proxyOf.nodes.splice(r + 1, 0, a);
    let n;
    for (let a in this.indexes)
      n = this.indexes[a], r < n && (this.indexes[a] = n + i.length);
    return this.markDirty(), this;
  }
  insertBefore(t, s) {
    let r = this.index(t), i = r === 0 ? "prepend" : !1, n = this.normalize(
      s,
      this.proxyOf.nodes[r],
      i
    ).reverse();
    r = this.index(t);
    for (let o of n) this.proxyOf.nodes.splice(r, 0, o);
    let a;
    for (let o in this.indexes)
      a = this.indexes[o], r <= a && (this.indexes[o] = a + n.length);
    return this.markDirty(), this;
  }
  normalize(t, s) {
    if (typeof t == "string")
      t = Me(Oe(t).nodes);
    else if (typeof t > "u")
      t = [];
    else if (Array.isArray(t)) {
      t = t.slice(0);
      for (let r of t)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (t.type === "root" && this.type !== "document") {
      t = t.nodes.slice(0);
      for (let r of t)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (t.type)
      t = [t];
    else if (t.prop) {
      if (typeof t.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof t.value != "string" && (t.value = String(t.value)), t = [new Ne(t)];
    } else if (t.selector || t.selectors)
      t = [new Gt(t)];
    else if (t.name)
      t = [new $t(t)];
    else if (t.text)
      t = [new Re(t)];
    else
      throw new Error("Unknown node type in node creation");
    return t.map((r) => (r[ve] || Ae.rebuild(r), r = r.proxyOf, r.parent && r.parent.removeChild(r), r[Se] && ke(r), r.raws || (r.raws = {}), typeof r.raws.before > "u" && s && typeof s.raws.before < "u" && (r.raws.before = s.raws.before.replace(/\S/g, "")), r.parent = this.proxyOf, r));
  }
  prepend(...t) {
    t = t.reverse();
    for (let s of t) {
      let r = this.normalize(s, this.first, "prepend").reverse();
      for (let i of r) this.proxyOf.nodes.unshift(i);
      for (let i in this.indexes)
        this.indexes[i] = this.indexes[i] + r.length;
    }
    return this.markDirty(), this;
  }
  push(t) {
    return t.parent = this, this.proxyOf.nodes.push(t), this;
  }
  removeAll() {
    for (let t of this.proxyOf.nodes) t.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(t) {
    t = this.index(t), this.proxyOf.nodes[t].parent = void 0, this.proxyOf.nodes.splice(t, 1);
    let s;
    for (let r in this.indexes)
      s = this.indexes[r], s >= t && (this.indexes[r] = s - 1);
    return this.markDirty(), this;
  }
  replaceValues(t, s, r) {
    return r || (r = s, s = {}), this.walkDecls((i) => {
      s.props && !s.props.includes(i.prop) || s.fast && !i.value.includes(s.fast) || (i.value = i.value.replace(t, r));
    }), this.markDirty(), this;
  }
  some(t) {
    return this.nodes.some(t);
  }
  walk(t) {
    return this.each((s, r) => {
      let i;
      try {
        i = t(s, r);
      } catch (n) {
        throw s.addToError(n);
      }
      return i !== !1 && s.walk && (i = s.walk(t)), i;
    });
  }
  walkAtRules(t, s) {
    return s ? t instanceof RegExp ? this.walk((r, i) => {
      if (r.type === "atrule" && t.test(r.name))
        return s(r, i);
    }) : this.walk((r, i) => {
      if (r.type === "atrule" && r.name === t)
        return s(r, i);
    }) : (s = t, this.walk((r, i) => {
      if (r.type === "atrule")
        return s(r, i);
    }));
  }
  walkComments(t) {
    return this.walk((s, r) => {
      if (s.type === "comment")
        return t(s, r);
    });
  }
  walkDecls(t, s) {
    return s ? t instanceof RegExp ? this.walk((r, i) => {
      if (r.type === "decl" && t.test(r.prop))
        return s(r, i);
    }) : this.walk((r, i) => {
      if (r.type === "decl" && r.prop === t)
        return s(r, i);
    }) : (s = t, this.walk((r, i) => {
      if (r.type === "decl")
        return s(r, i);
    }));
  }
  walkRules(t, s) {
    return s ? t instanceof RegExp ? this.walk((r, i) => {
      if (r.type === "rule" && t.test(r.selector))
        return s(r, i);
    }) : this.walk((r, i) => {
      if (r.type === "rule" && r.selector === t)
        return s(r, i);
    }) : (s = t, this.walk((r, i) => {
      if (r.type === "rule")
        return s(r, i);
    }));
  }
};
k.registerParse = (e) => {
  Oe = e;
};
k.registerRule = (e) => {
  Gt = e;
};
k.registerAtRule = (e) => {
  $t = e;
};
k.registerRoot = (e) => {
  De = e;
};
var T = k;
k.default = k;
k.rebuild = (e) => {
  e.type === "atrule" ? Object.setPrototypeOf(e, $t.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, Gt.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, Ne.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, Re.prototype) : e.type === "root" && Object.setPrototypeOf(e, De.prototype), e[ve] = !0, e.nodes && e.nodes.forEach((t) => {
    k.rebuild(t);
  });
};
let Te = T, ot = class extends Te {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var Wt = ot;
ot.default = ot;
Te.registerAtRule(ot);
let Ts = T, Ie, _e, $ = class extends Ts {
  constructor(e) {
    super({ type: "document", ...e }), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new Ie(new _e(), this, e).stringify();
  }
};
$.registerLazyResult = (e) => {
  Ie = e;
};
$.registerProcessor = (e) => {
  _e = e;
};
var Vt = $;
$.default = $;
let Is = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", _s = (e = 21) => {
  let t = "", s = e | 0;
  for (; s--; )
    t += Is[Math.random() * 64 | 0];
  return t;
};
var Ps = { nanoid: _s };
let { existsSync: Us, readFileSync: Ls } = S, { dirname: yt, join: Fs } = S, { SourceMapConsumer: ne, SourceMapGenerator: oe } = S;
function Bs(e) {
  return Buffer ? Buffer.from(e, "base64").toString() : window.atob(e);
}
let Mt = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let s = t.map ? t.map.prev : void 0, r = this.loadMap(t.from, s);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = yt(this.mapFile)), r && (this.text = r);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new ne(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, s = /^data:application\/json;base64,/, r = /^data:application\/json;charset=utf-?8,/, i = /^data:application\/json,/, n = e.match(r) || e.match(i);
    if (n)
      return decodeURIComponent(e.substr(n[0].length));
    let a = e.match(t) || e.match(s);
    if (a)
      return Bs(e.substr(a[0].length));
    let o = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + o);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let s = e.lastIndexOf(t.pop()), r = e.indexOf("*/", s);
    s > -1 && r > -1 && (this.annotation = this.getAnnotationURL(e.substring(s, r)));
  }
  loadFile(e) {
    if (this.root = yt(e), Us(e))
      return this.mapFile = e, Ls(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let s = t(e);
        if (s) {
          let r = this.loadFile(s);
          if (!r)
            throw new Error(
              "Unable to load previous source map: " + s.toString()
            );
          return r;
        }
      } else {
        if (t instanceof ne)
          return oe.fromSourceMap(t).toString();
        if (t instanceof oe)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let s = this.annotation;
        return e && (s = Fs(yt(e), s)), this.loadFile(s);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Pe = Mt;
Mt.default = Mt;
let { nanoid: js } = Ps, { isAbsolute: kt, resolve: At } = S, { SourceMapConsumer: zs, SourceMapGenerator: $s } = S, { fileURLToPath: ae, pathToFileURL: X } = S, le = zt, Gs = Pe, bt = S, Et = Symbol("fromOffsetCache"), Ws = !!(zs && $s), ue = !!(At && kt), at = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e > "u" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!ue || /^\w+:\/\//.test(t.from) || kt(t.from) ? this.file = t.from : this.file = At(t.from)), ue && Ws) {
      let s = new Gs(this.css, t);
      if (s.text) {
        this.map = s;
        let r = s.consumer().file;
        !this.file && r && (this.file = this.mapResolve(r));
      }
    }
    this.file || (this.id = "<input css " + js(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, s, r = {}) {
    let i, n, a;
    if (t && typeof t == "object") {
      let l = t, p = s;
      if (typeof l.offset == "number") {
        let u = this.fromOffset(l.offset);
        t = u.line, s = u.col;
      } else
        t = l.line, s = l.column;
      if (typeof p.offset == "number") {
        let u = this.fromOffset(p.offset);
        n = u.line, i = u.col;
      } else
        n = p.line, i = p.column;
    } else if (!s) {
      let l = this.fromOffset(t);
      t = l.line, s = l.col;
    }
    let o = this.origin(t, s, n, i);
    return o ? a = new le(
      e,
      o.endLine === void 0 ? o.line : { column: o.column, line: o.line },
      o.endLine === void 0 ? o.column : { column: o.endColumn, line: o.endLine },
      o.source,
      o.file,
      r.plugin
    ) : a = new le(
      e,
      n === void 0 ? t : { column: s, line: t },
      n === void 0 ? s : { column: i, line: n },
      this.css,
      this.file,
      r.plugin
    ), a.input = { column: s, endColumn: i, endLine: n, line: t, source: this.css }, this.file && (X && (a.input.url = X(this.file).toString()), a.input.file = this.file), a;
  }
  fromOffset(e) {
    let t, s;
    if (this[Et])
      s = this[Et];
    else {
      let i = this.css.split(`
`);
      s = new Array(i.length);
      let n = 0;
      for (let a = 0, o = i.length; a < o; a++)
        s[a] = n, n += i[a].length + 1;
      this[Et] = s;
    }
    t = s[s.length - 1];
    let r = 0;
    if (e >= t)
      r = s.length - 1;
    else {
      let i = s.length - 2, n;
      for (; r < i; )
        if (n = r + (i - r >> 1), e < s[n])
          i = n - 1;
        else if (e >= s[n + 1])
          r = n + 1;
        else {
          r = n;
          break;
        }
    }
    return {
      col: e - s[r] + 1,
      line: r + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : At(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, s, r) {
    if (!this.map) return !1;
    let i = this.map.consumer(), n = i.originalPositionFor({ column: t, line: e });
    if (!n.source) return !1;
    let a;
    typeof s == "number" && (a = i.originalPositionFor({ column: r, line: s }));
    let o;
    kt(n.source) ? o = X(n.source) : o = new URL(
      n.source,
      this.map.consumer().sourceRoot || X(this.map.mapFile)
    );
    let l = {
      column: n.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: n.line,
      url: o.toString()
    };
    if (o.protocol === "file:")
      if (ae)
        l.file = ae(o);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let p = i.sourceContentFor(n.source);
    return p && (l.source = p), l;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = { ...this.map }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var dt = at;
at.default = at;
bt && bt.registerInput && bt.registerInput(at);
let Ue = T, Le, Fe, P = class extends Ue {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, s) {
    let r = super.normalize(e);
    if (t) {
      if (s === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let i of r)
          i.raws.before = t.raws.before;
    }
    return r;
  }
  removeChild(e, t) {
    let s = this.index(e);
    return !t && s === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[s].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new Le(new Fe(), this, e).stringify();
  }
};
P.registerLazyResult = (e) => {
  Le = e;
};
P.registerProcessor = (e) => {
  Fe = e;
};
var J = P;
P.default = P;
Ue.registerRoot(P);
let G = {
  comma(e) {
    return G.split(e, [","], !0);
  },
  space(e) {
    let t = [" ", `
`, "	"];
    return G.split(e, t);
  },
  split(e, t, s) {
    let r = [], i = "", n = !1, a = 0, o = !1, l = "", p = !1;
    for (let u of e)
      p ? p = !1 : u === "\\" ? p = !0 : o ? u === l && (o = !1) : u === '"' || u === "'" ? (o = !0, l = u) : u === "(" ? a += 1 : u === ")" ? a > 0 && (a -= 1) : a === 0 && t.includes(u) && (n = !0), n ? (i !== "" && r.push(i.trim()), i = "", n = !1) : i += u;
    return (s || i !== "") && r.push(i.trim()), r;
  }
};
var Be = G;
G.default = G;
let je = T, Vs = Be, lt = class extends je {
  get selectors() {
    return Vs.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, s = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(s);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var Yt = lt;
lt.default = lt;
je.registerRule(lt);
let Ys = Wt, Js = pt, Hs = ft, Xs = dt, Zs = Pe, qs = J, Ks = Yt;
function W(e, t) {
  if (Array.isArray(e)) return e.map((i) => W(i));
  let { inputs: s, ...r } = e;
  if (s) {
    t = [];
    for (let i of s) {
      let n = { ...i, __proto__: Xs.prototype };
      n.map && (n.map = {
        ...n.map,
        __proto__: Zs.prototype
      }), t.push(n);
    }
  }
  if (r.nodes && (r.nodes = e.nodes.map((i) => W(i, t))), r.source) {
    let { inputId: i, ...n } = r.source;
    r.source = n, i != null && (r.source.input = t[i]);
  }
  if (r.type === "root")
    return new qs(r);
  if (r.type === "decl")
    return new Hs(r);
  if (r.type === "rule")
    return new Ks(r);
  if (r.type === "comment")
    return new Js(r);
  if (r.type === "atrule")
    return new Ys(r);
  throw new Error("Unknown node type: " + e.type);
}
var Qs = W;
W.default = W;
let { dirname: rt, relative: ze, resolve: $e, sep: Ge } = S, { SourceMapConsumer: We, SourceMapGenerator: it } = S, { pathToFileURL: ce } = S, tr = dt, er = !!(We && it), sr = !!(rt && $e && ze && Ge), rr = class {
  constructor(e, t, s, r) {
    this.stringify = e, this.mapOpts = s.map || {}, this.root = t, this.opts = s, this.css = r, this.originalCSS = r, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), s = e.root || rt(e.file), r;
      this.mapOpts.sourcesContent === !1 ? (r = new We(e.text), r.sourcesContent && (r.sourcesContent = null)) : r = e.consumer(), this.map.applySourceMap(r, t, this.toUrl(this.path(s)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), sr && er && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = it.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new it({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new it({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, s = "<no source>", r = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, i, n;
    this.stringify(this.root, (a, o, l) => {
      if (this.css += a, o && l !== "end" && (r.generated.line = e, r.generated.column = t - 1, o.source && o.source.start ? (r.source = this.sourcePath(o), r.original.line = o.source.start.line, r.original.column = o.source.start.column - 1, this.map.addMapping(r)) : (r.source = s, r.original.line = 1, r.original.column = 0, this.map.addMapping(r))), n = a.match(/\n/g), n ? (e += n.length, i = a.lastIndexOf(`
`), t = a.length - i) : t += a.length, o && l !== "start") {
        let p = o.parent || { raws: {} };
        (!(o.type === "decl" || o.type === "atrule" && !o.nodes) || o !== p.last || p.raws.semicolon) && (o.source && o.source.end ? (r.source = this.sourcePath(o), r.original.line = o.source.end.line, r.original.column = o.source.end.column - 1, r.generated.line = e, r.generated.column = t - 2, this.map.addMapping(r)) : (r.source = s, r.original.line = 1, r.original.column = 0, r.generated.line = e, r.generated.column = t - 1, this.map.addMapping(r)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let s = this.opts.to ? rt(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (s = rt($e(s, this.mapOpts.annotation)));
    let r = ze(s, e);
    return this.memoizedPaths.set(e, r), r;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new tr(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let s = t.source.input.from;
          if (s && !e[s]) {
            e[s] = !0;
            let r = this.usesFileUrls ? this.toFileUrl(s) : this.toUrl(this.path(s));
            this.map.setSourceContent(r, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (ce) {
      let s = ce(e).toString();
      return this.memoizedFileURLs.set(e, s), s;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    Ge === "\\" && (e = e.replace(/\\/g, "/"));
    let s = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, s), s;
  }
};
var Ve = rr;
const xt = 39, he = 34, Z = 92, pe = 47, q = 10, j = 32, K = 12, Q = 9, tt = 13, ir = 91, nr = 93, or = 40, ar = 41, lr = 123, ur = 125, cr = 59, hr = 42, pr = 58, fr = 64, et = /[\t\n\f\r "#'()/;[\\\]{}]/g, st = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, dr = /.[\r\n"'(/\\]/, fe = /[\da-f]/i;
var mr = function(e, t = {}) {
  let s = e.css.valueOf(), r = t.ignoreErrors, i, n, a, o, l, p, u, m, w, E, D = s.length, h = 0, v = [], N = [];
  function x() {
    return h;
  }
  function b(I) {
    throw e.error("Unclosed " + I, h);
  }
  function M() {
    return N.length === 0 && h >= D;
  }
  function gt(I) {
    if (N.length) return N.pop();
    if (h >= D) return;
    let wt = I ? I.ignoreUnclosed : !1;
    switch (i = s.charCodeAt(h), i) {
      case q:
      case j:
      case Q:
      case tt:
      case K: {
        o = h;
        do
          o += 1, i = s.charCodeAt(o);
        while (i === j || i === q || i === Q || i === tt || i === K);
        p = ["space", s.slice(h, o)], h = o - 1;
        break;
      }
      case ir:
      case nr:
      case lr:
      case ur:
      case pr:
      case cr:
      case ar: {
        let te = String.fromCharCode(i);
        p = [te, te, h];
        break;
      }
      case or: {
        if (E = v.length ? v.pop()[1] : "", w = s.charCodeAt(h + 1), E === "url" && w !== xt && w !== he && w !== j && w !== q && w !== Q && w !== K && w !== tt) {
          o = h;
          do {
            if (u = !1, o = s.indexOf(")", o + 1), o === -1)
              if (r || wt) {
                o = h;
                break;
              } else
                b("bracket");
            for (m = o; s.charCodeAt(m - 1) === Z; )
              m -= 1, u = !u;
          } while (u);
          p = ["brackets", s.slice(h, o + 1), h, o], h = o;
        } else
          o = s.indexOf(")", h + 1), n = s.slice(h, o + 1), o === -1 || dr.test(n) ? p = ["(", "(", h] : (p = ["brackets", n, h, o], h = o);
        break;
      }
      case xt:
      case he: {
        l = i === xt ? "'" : '"', o = h;
        do {
          if (u = !1, o = s.indexOf(l, o + 1), o === -1)
            if (r || wt) {
              o = h + 1;
              break;
            } else
              b("string");
          for (m = o; s.charCodeAt(m - 1) === Z; )
            m -= 1, u = !u;
        } while (u);
        p = ["string", s.slice(h, o + 1), h, o], h = o;
        break;
      }
      case fr: {
        et.lastIndex = h + 1, et.test(s), et.lastIndex === 0 ? o = s.length - 1 : o = et.lastIndex - 2, p = ["at-word", s.slice(h, o + 1), h, o], h = o;
        break;
      }
      case Z: {
        for (o = h, a = !0; s.charCodeAt(o + 1) === Z; )
          o += 1, a = !a;
        if (i = s.charCodeAt(o + 1), a && i !== pe && i !== j && i !== q && i !== Q && i !== tt && i !== K && (o += 1, fe.test(s.charAt(o)))) {
          for (; fe.test(s.charAt(o + 1)); )
            o += 1;
          s.charCodeAt(o + 1) === j && (o += 1);
        }
        p = ["word", s.slice(h, o + 1), h, o], h = o;
        break;
      }
      default: {
        i === pe && s.charCodeAt(h + 1) === hr ? (o = s.indexOf("*/", h + 2) + 1, o === 0 && (r || wt ? o = s.length : b("comment")), p = ["comment", s.slice(h, o + 1), h, o], h = o) : (st.lastIndex = h + 1, st.test(s), st.lastIndex === 0 ? o = s.length - 1 : o = st.lastIndex - 2, p = ["word", s.slice(h, o + 1), h, o], v.push(p), h = o);
        break;
      }
    }
    return h++, p;
  }
  function hs(I) {
    N.push(I);
  }
  return {
    back: hs,
    endOfFile: M,
    nextToken: gt,
    position: x
  };
};
let gr = Wt, wr = pt, yr = ft, br = J, de = Yt, Er = mr;
const me = {
  empty: !0,
  space: !0
};
function xr(e) {
  for (let t = e.length - 1; t >= 0; t--) {
    let s = e[t], r = s[3] || s[2];
    if (r) return r;
  }
}
let Cr = class {
  constructor(e) {
    this.input = e, this.root = new br(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new gr();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let s, r, i, n = !1, a = !1, o = [], l = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), s = e[0], s === "(" || s === "[" ? l.push(s === "(" ? ")" : "]") : s === "{" && l.length > 0 ? l.push("}") : s === l[l.length - 1] && l.pop(), l.length === 0)
        if (s === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (s === "{") {
          a = !0;
          break;
        } else if (s === "}") {
          if (o.length > 0) {
            for (i = o.length - 1, r = o[i]; r && r[0] === "space"; )
              r = o[--i];
            r && (t.source.end = this.getPosition(r[3] || r[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          o.push(e);
      else
        o.push(e);
      if (this.tokenizer.endOfFile()) {
        n = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(o), o.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(o), this.raw(t, "params", o), n && (e = o[o.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let s = 0, r;
    for (let i = t - 1; i >= 0 && (r = e[i], !(r[0] !== "space" && (s += 1, s === 2))); i--)
      ;
    throw this.input.error(
      "Missed semicolon",
      r[0] === "word" ? r[3] + 1 : r[2]
    );
  }
  colon(e) {
    let t = 0, s, r, i;
    for (let [n, a] of e.entries()) {
      if (r = a, i = r[0], i === "(" && (t += 1), i === ")" && (t -= 1), t === 0 && i === ":")
        if (!s)
          this.doubleColon(r);
        else {
          if (s[0] === "word" && s[1] === "progid")
            continue;
          return n;
        }
      s = r;
    }
    return !1;
  }
  comment(e) {
    let t = new wr();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let s = e[1].slice(2, -2);
    if (/^\s*$/.test(s))
      t.text = "", t.raws.left = s, t.raws.right = "";
    else {
      let r = s.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = r[2], t.raws.left = r[1], t.raws.right = r[3];
    }
  }
  createTokenizer() {
    this.tokenizer = Er(this.input);
  }
  decl(e, t) {
    let s = new yr();
    this.init(s, e[0][2]);
    let r = e[e.length - 1];
    for (r[0] === ";" && (this.semicolon = !0, e.pop()), s.source.end = this.getPosition(
      r[3] || r[2] || xr(e)
    ), s.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), s.raws.before += e.shift()[1];
    for (s.source.start = this.getPosition(e[0][2]), s.prop = ""; e.length; ) {
      let o = e[0][0];
      if (o === ":" || o === "space" || o === "comment")
        break;
      s.prop += e.shift()[1];
    }
    s.raws.between = "";
    let i;
    for (; e.length; )
      if (i = e.shift(), i[0] === ":") {
        s.raws.between += i[1];
        break;
      } else
        i[0] === "word" && /\w/.test(i[1]) && this.unknownWord([i]), s.raws.between += i[1];
    (s.prop[0] === "_" || s.prop[0] === "*") && (s.raws.before += s.prop[0], s.prop = s.prop.slice(1));
    let n = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      n.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let o = e.length - 1; o >= 0; o--) {
      if (i = e[o], i[1].toLowerCase() === "!important") {
        s.important = !0;
        let l = this.stringFrom(e, o);
        l = this.spacesFromEnd(e) + l, l !== " !important" && (s.raws.important = l);
        break;
      } else if (i[1].toLowerCase() === "important") {
        let l = e.slice(0), p = "";
        for (let u = o; u > 0; u--) {
          let m = l[u][0];
          if (p.trim().startsWith("!") && m !== "space")
            break;
          p = l.pop()[1] + p;
        }
        p.trim().startsWith("!") && (s.important = !0, s.raws.important = p, e = l);
      }
      if (i[0] !== "space" && i[0] !== "comment")
        break;
    }
    e.some((o) => o[0] !== "space" && o[0] !== "comment") && (s.raws.between += n.map((o) => o[1]).join(""), n = []), this.raw(s, "value", n.concat(e), t), s.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new de();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, s = null, r = !1, i = null, n = [], a = e[1].startsWith("--"), o = [], l = e;
    for (; l; ) {
      if (s = l[0], o.push(l), s === "(" || s === "[")
        i || (i = l), n.push(s === "(" ? ")" : "]");
      else if (a && r && s === "{")
        i || (i = l), n.push("}");
      else if (n.length === 0)
        if (s === ";")
          if (r) {
            this.decl(o, a);
            return;
          } else
            break;
        else if (s === "{") {
          this.rule(o);
          return;
        } else if (s === "}") {
          this.tokenizer.back(o.pop()), t = !0;
          break;
        } else s === ":" && (r = !0);
      else s === n[n.length - 1] && (n.pop(), n.length === 0 && (i = null));
      l = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), n.length > 0 && this.unclosedBracket(i), t && r) {
      if (!a)
        for (; o.length && (l = o[o.length - 1][0], !(l !== "space" && l !== "comment")); )
          this.tokenizer.back(o.pop());
      this.decl(o, a);
    } else
      this.unknownWord(o);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, s, r) {
    let i, n, a = s.length, o = "", l = !0, p, u;
    for (let m = 0; m < a; m += 1)
      i = s[m], n = i[0], n === "space" && m === a - 1 && !r ? l = !1 : n === "comment" ? (u = s[m - 1] ? s[m - 1][0] : "empty", p = s[m + 1] ? s[m + 1][0] : "empty", !me[u] && !me[p] ? o.slice(-1) === "," ? l = !1 : o += i[1] : l = !1) : o += i[1];
    if (!l) {
      let m = s.reduce((w, E) => w + E[1], "");
      e.raws[t] = { raw: m, value: o };
    }
    e[t] = o;
  }
  rule(e) {
    e.pop();
    let t = new de();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, s = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      s = e.pop()[1] + s;
    return s;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, s = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      s += e.shift()[1];
    return s;
  }
  spacesFromEnd(e) {
    let t, s = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      s = e.pop()[1] + s;
    return s;
  }
  stringFrom(e, t) {
    let s = "";
    for (let r = t; r < e.length; r++)
      s += e[r][1];
    return e.splice(t, e.length - t), s;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var Rr = Cr;
let Nr = T, Sr = dt, vr = Rr;
function ut(e, t) {
  let s = new Sr(e, t), r = new vr(s);
  try {
    r.parse();
  } catch (i) {
    throw process.env.NODE_ENV !== "production" && i.name === "CssSyntaxError" && t && t.from && (/\.scss$/i.test(t.from) ? i.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(t.from) ? i.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(t.from) && (i.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), i;
  }
  return r.root;
}
var Jt = ut;
ut.default = ut;
Nr.registerParse(ut);
let Tt = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let s = t.node.rangeBy(t);
      this.line = s.start.line, this.column = s.start.column, this.endLine = s.end.line, this.endColumn = s.end.column;
    }
    for (let s in t) this[s] = t[s];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var Ye = Tt;
Tt.default = Tt;
let Or = Ye, It = class {
  get content() {
    return this.css;
  }
  constructor(e, t, s) {
    this.processor = e, this.messages = [], this.root = t, this.opts = s, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let s = new Or(e, t);
    return this.messages.push(s), s;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var Ht = It;
It.default = It;
let ge = {};
var Je = function(e) {
  ge[e] || (ge[e] = !0, typeof console < "u" && console.warn && console.warn(e));
};
let Dr = T, Mr = Vt, kr = Ve, Ar = Jt, we = Ht, Tr = J, Ir = ct, { isClean: O, my: _r } = Y, Pr = Je;
const Ur = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, Lr = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, Fr = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, U = 0;
function z(e) {
  return typeof e == "object" && typeof e.then == "function";
}
function He(e) {
  let t = !1, s = Ur[e.type];
  return e.type === "decl" ? t = e.prop.toLowerCase() : e.type === "atrule" && (t = e.name.toLowerCase()), t && e.append ? [
    s,
    s + "-" + t,
    U,
    s + "Exit",
    s + "Exit-" + t
  ] : t ? [s, s + "-" + t, s + "Exit", s + "Exit-" + t] : e.append ? [s, U, s + "Exit"] : [s, s + "Exit"];
}
function ye(e) {
  let t;
  return e.type === "document" ? t = ["Document", U, "DocumentExit"] : e.type === "root" ? t = ["Root", U, "RootExit"] : t = He(e), {
    eventIndex: 0,
    events: t,
    iterator: 0,
    node: e,
    visitorIndex: 0,
    visitors: []
  };
}
function _t(e) {
  return e[O] = !1, e.nodes && e.nodes.forEach((t) => _t(t)), e;
}
let Pt = {}, L = class Xe {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(t, s, r) {
    this.stringified = !1, this.processed = !1;
    let i;
    if (typeof s == "object" && s !== null && (s.type === "root" || s.type === "document"))
      i = _t(s);
    else if (s instanceof Xe || s instanceof we)
      i = _t(s.root), s.map && (typeof r.map > "u" && (r.map = {}), r.map.inline || (r.map.inline = !1), r.map.prev = s.map);
    else {
      let n = Ar;
      r.syntax && (n = r.syntax.parse), r.parser && (n = r.parser), n.parse && (n = n.parse);
      try {
        i = n(s, r);
      } catch (a) {
        this.processed = !0, this.error = a;
      }
      i && !i[_r] && Dr.rebuild(i);
    }
    this.result = new we(t, i, r), this.helpers = { ...Pt, postcss: Pt, result: this.result }, this.plugins = this.processor.plugins.map((n) => typeof n == "object" && n.prepare ? { ...n, ...n.prepare(this.result) } : n);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(t) {
    return this.async().catch(t);
  }
  finally(t) {
    return this.async().then(t, t);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(t, s) {
    let r = this.result.lastPlugin;
    try {
      if (s && s.addToError(t), this.error = t, t.name === "CssSyntaxError" && !t.plugin)
        t.plugin = r.postcssPlugin, t.setMessage();
      else if (r.postcssVersion && process.env.NODE_ENV !== "production") {
        let i = r.postcssPlugin, n = r.postcssVersion, a = this.result.processor.version, o = n.split("."), l = a.split(".");
        (o[0] !== l[0] || parseInt(o[1]) > parseInt(l[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + a + ", but " + i + " uses " + n + ". Perhaps this is the source of the error below."
        );
      }
    } catch (i) {
      console && console.error && console.error(i);
    }
    return t;
  }
  prepareVisitors() {
    this.listeners = {};
    let t = (s, r, i) => {
      this.listeners[r] || (this.listeners[r] = []), this.listeners[r].push([s, i]);
    };
    for (let s of this.plugins)
      if (typeof s == "object")
        for (let r in s) {
          if (!Lr[r] && /^[A-Z]/.test(r))
            throw new Error(
              `Unknown event ${r} in ${s.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!Fr[r])
            if (typeof s[r] == "object")
              for (let i in s[r])
                i === "*" ? t(s, r, s[r][i]) : t(
                  s,
                  r + "-" + i.toLowerCase(),
                  s[r][i]
                );
            else typeof s[r] == "function" && t(s, r, s[r]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let t = 0; t < this.plugins.length; t++) {
      let s = this.plugins[t], r = this.runOnRoot(s);
      if (z(r))
        try {
          await r;
        } catch (i) {
          throw this.handleError(i);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[O]; ) {
        t[O] = !0;
        let s = [ye(t)];
        for (; s.length > 0; ) {
          let r = this.visitTick(s);
          if (z(r))
            try {
              await r;
            } catch (i) {
              let n = s[s.length - 1].node;
              throw this.handleError(i, n);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [s, r] of this.listeners.OnceExit) {
          this.result.lastPlugin = s;
          try {
            if (t.type === "document") {
              let i = t.nodes.map(
                (n) => r(n, this.helpers)
              );
              await Promise.all(i);
            } else
              await r(t, this.helpers);
          } catch (i) {
            throw this.handleError(i);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(t) {
    this.result.lastPlugin = t;
    try {
      if (typeof t == "object" && t.Once) {
        if (this.result.root.type === "document") {
          let s = this.result.root.nodes.map(
            (r) => t.Once(r, this.helpers)
          );
          return z(s[0]) ? Promise.all(s) : s;
        }
        return t.Once(this.result.root, this.helpers);
      } else if (typeof t == "function")
        return t(this.result.root, this.result);
    } catch (s) {
      throw this.handleError(s);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let t = this.result.opts, s = Ir;
    t.syntax && (s = t.syntax.stringify), t.stringifier && (s = t.stringifier), s.stringify && (s = s.stringify);
    let r = new kr(s, this.result.root, this.result.opts).generate();
    return this.result.css = r[0], this.result.map = r[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let t of this.plugins) {
      let s = this.runOnRoot(t);
      if (z(s))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[O]; )
        t[O] = !0, this.walkSync(t);
      if (this.listeners.OnceExit)
        if (t.type === "document")
          for (let s of t.nodes)
            this.visitSync(this.listeners.OnceExit, s);
        else
          this.visitSync(this.listeners.OnceExit, t);
    }
    return this.result;
  }
  then(t, s) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || Pr(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(t, s);
  }
  toString() {
    return this.css;
  }
  visitSync(t, s) {
    for (let [r, i] of t) {
      this.result.lastPlugin = r;
      let n;
      try {
        n = i(s, this.helpers);
      } catch (a) {
        throw this.handleError(a, s.proxyOf);
      }
      if (s.type !== "root" && s.type !== "document" && !s.parent)
        return !0;
      if (z(n))
        throw this.getAsyncError();
    }
  }
  visitTick(t) {
    let s = t[t.length - 1], { node: r, visitors: i } = s;
    if (r.type !== "root" && r.type !== "document" && !r.parent) {
      t.pop();
      return;
    }
    if (i.length > 0 && s.visitorIndex < i.length) {
      let [a, o] = i[s.visitorIndex];
      s.visitorIndex += 1, s.visitorIndex === i.length && (s.visitors = [], s.visitorIndex = 0), this.result.lastPlugin = a;
      try {
        return o(r.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, r);
      }
    }
    if (s.iterator !== 0) {
      let a = s.iterator, o;
      for (; o = r.nodes[r.indexes[a]]; )
        if (r.indexes[a] += 1, !o[O]) {
          o[O] = !0, t.push(ye(o));
          return;
        }
      s.iterator = 0, delete r.indexes[a];
    }
    let n = s.events;
    for (; s.eventIndex < n.length; ) {
      let a = n[s.eventIndex];
      if (s.eventIndex += 1, a === U) {
        r.nodes && r.nodes.length && (r[O] = !0, s.iterator = r.getIterator());
        return;
      } else if (this.listeners[a]) {
        s.visitors = this.listeners[a];
        return;
      }
    }
    t.pop();
  }
  walkSync(t) {
    t[O] = !0;
    let s = He(t);
    for (let r of s)
      if (r === U)
        t.nodes && t.each((i) => {
          i[O] || this.walkSync(i);
        });
      else {
        let i = this.listeners[r];
        if (i && this.visitSync(i, t.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
L.registerPostcss = (e) => {
  Pt = e;
};
var Ze = L;
L.default = L;
Tr.registerLazyResult(L);
Mr.registerLazyResult(L);
let Br = Ve, jr = Jt;
const zr = Ht;
let $r = ct, Gr = Je, Ut = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = jr;
    try {
      e = t(this._css, this._opts);
    } catch (s) {
      this.error = s;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, s) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = s, this._map = void 0;
    let r, i = $r;
    this.result = new zr(this._processor, r, this._opts), this.result.css = t;
    let n = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return n.root;
      }
    });
    let a = new Br(i, r, this._opts, t);
    if (a.isMap()) {
      let [o, l] = a.generate();
      o && (this.result.css = o), l && (this.result.map = l);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || Gr(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var Wr = Ut;
Ut.default = Ut;
let Vr = Vt, Yr = Ze, Jr = Wr, Hr = J, V = class {
  constructor(e = []) {
    this.version = "8.5.3", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let s of e)
      if (s.postcss === !0 ? s = s() : s.postcss && (s = s.postcss), typeof s == "object" && Array.isArray(s.plugins))
        t = t.concat(s.plugins);
      else if (typeof s == "object" && s.postcssPlugin)
        t.push(s);
      else if (typeof s == "function")
        t.push(s);
      else if (typeof s == "object" && (s.parse || s.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(s + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new Jr(this, e, t) : new Yr(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var Xr = V;
V.default = V;
Hr.registerProcessor(V);
Vr.registerProcessor(V);
let qe = Wt, Ke = pt, Zr = T, qr = zt, Qe = ft, ts = Vt, Kr = Qs, Qr = dt, ti = Ze, ei = Be, si = ht, ri = Jt, Xt = Xr, ii = Ht, es = J, ss = Yt, ni = ct, oi = Ye;
function g(...e) {
  return e.length === 1 && Array.isArray(e[0]) && (e = e[0]), new Xt(e);
}
g.plugin = function(e, t) {
  let s = !1;
  function r(...n) {
    console && console.warn && !s && (s = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...n);
    return a.postcssPlugin = e, a.postcssVersion = new Xt().version, a;
  }
  let i;
  return Object.defineProperty(r, "postcss", {
    get() {
      return i || (i = r()), i;
    }
  }), r.process = function(n, a, o) {
    return g([r(o)]).process(n, a);
  }, r;
};
g.stringify = ni;
g.parse = ri;
g.fromJSON = Kr;
g.list = ei;
g.comment = (e) => new Ke(e);
g.atRule = (e) => new qe(e);
g.decl = (e) => new Qe(e);
g.rule = (e) => new ss(e);
g.root = (e) => new es(e);
g.document = (e) => new ts(e);
g.CssSyntaxError = qr;
g.Declaration = Qe;
g.Container = Zr;
g.Processor = Xt;
g.Document = ts;
g.Comment = Ke;
g.Warning = oi;
g.AtRule = qe;
g.Result = ii;
g.Input = Qr;
g.Rule = ss;
g.Root = es;
g.Node = si;
ti.registerPostcss(g);
var ai = g;
g.default = g;
const y = /* @__PURE__ */ ys(ai);
y.stringify;
y.fromJSON;
y.plugin;
y.parse;
y.list;
y.document;
y.comment;
y.atRule;
y.rule;
y.decl;
y.root;
y.CssSyntaxError;
y.Declaration;
y.Container;
y.Processor;
y.Document;
y.Comment;
y.Warning;
y.AtRule;
y.Result;
y.Input;
y.Rule;
y.Root;
y.Node;
function li(e) {
  const t = {}, s = /;(?![^(]*\))/g, r = /:(.+)/, i = /\/\*.*?\*\//g;
  return e.replace(i, "").split(s).forEach(function(n) {
    if (n) {
      const a = n.split(r);
      a.length > 1 && (t[Lt(a[0].trim())] = a[1].trim());
    }
  }), t;
}
function be(e) {
  const t = [];
  for (const s in e) {
    const r = e[s];
    if (typeof r != "string") continue;
    const i = pi(s);
    t.push(`${i}: ${r};`);
  }
  return t.join(" ");
}
const ui = /-([a-z])/g, ci = /^--[a-zA-Z0-9-]+$/, Lt = (e) => ci.test(e) ? e : e.replace(ui, (t, s) => s ? s.toUpperCase() : ""), hi = /\B([A-Z])/g, pi = (e) => e.replace(hi, "-$1").toLowerCase();
class A {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  constructor(...t) {
    c(this, "parentElement", null);
    c(this, "parentNode", null);
    c(this, "ownerDocument");
    c(this, "firstChild", null);
    c(this, "lastChild", null);
    c(this, "previousSibling", null);
    c(this, "nextSibling", null);
    c(this, "ELEMENT_NODE", 1);
    c(this, "TEXT_NODE", 3);
    // corresponding nodeType value of standard HTML Node
    c(this, "nodeType");
    c(this, "nodeName");
    c(this, "RRNodeType");
  }
  get childNodes() {
    const t = [];
    let s = this.firstChild;
    for (; s; )
      t.push(s), s = s.nextSibling;
    return t;
  }
  contains(t) {
    if (t instanceof A) {
      if (t.ownerDocument !== this.ownerDocument) return !1;
      if (t === this) return !0;
    } else return !1;
    for (; t.parentNode; ) {
      if (t.parentNode === this) return !0;
      t = t.parentNode;
    }
    return !1;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  appendChild(t) {
    throw new Error(
      "RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  insertBefore(t, s) {
    throw new Error(
      "RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeChild(t) {
    throw new Error(
      "RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  toString() {
    return "RRNode";
  }
}
class Zt extends A {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(...s) {
    super(s);
    c(this, "nodeType", 9);
    c(this, "nodeName", "#document");
    c(this, "compatMode", "CSS1Compat");
    c(this, "RRNodeType", d.Document);
    c(this, "textContent", null);
    this.ownerDocument = this;
  }
  get documentElement() {
    return this.childNodes.find(
      (s) => s.RRNodeType === d.Element && s.tagName === "HTML"
    ) || null;
  }
  get body() {
    var s;
    return ((s = this.documentElement) == null ? void 0 : s.childNodes.find(
      (r) => r.RRNodeType === d.Element && r.tagName === "BODY"
    )) || null;
  }
  get head() {
    var s;
    return ((s = this.documentElement) == null ? void 0 : s.childNodes.find(
      (r) => r.RRNodeType === d.Element && r.tagName === "HEAD"
    )) || null;
  }
  get implementation() {
    return this;
  }
  get firstElementChild() {
    return this.documentElement;
  }
  appendChild(s) {
    const r = s.RRNodeType;
    if ((r === d.Element || r === d.DocumentType) && this.childNodes.some((n) => n.RRNodeType === r))
      throw new Error(
        `RRDomException: Failed to execute 'appendChild' on 'RRNode': Only one ${r === d.Element ? "RRElement" : "RRDoctype"} on RRDocument allowed.`
      );
    const i = Kt(this, s);
    return i.parentElement = null, i;
  }
  insertBefore(s, r) {
    const i = s.RRNodeType;
    if ((i === d.Element || i === d.DocumentType) && this.childNodes.some((a) => a.RRNodeType === i))
      throw new Error(
        `RRDomException: Failed to execute 'insertBefore' on 'RRNode': Only one ${i === d.Element ? "RRElement" : "RRDoctype"} on RRDocument allowed.`
      );
    const n = as(this, s, r);
    return n.parentElement = null, n;
  }
  removeChild(s) {
    return ls(this, s);
  }
  open() {
    this.firstChild = null, this.lastChild = null;
  }
  close() {
  }
  /**
   * Adhoc implementation for setting xhtml namespace in rebuilt.ts (rrweb-snapshot).
   * There are two lines used this function:
   * 1. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" ""\>')
   * 2. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" ""\>')
   */
  write(s) {
    let r;
    if (s === '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">' ? r = "-//W3C//DTD XHTML 1.0 Transitional//EN" : s === '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">' && (r = "-//W3C//DTD HTML 4.0 Transitional//EN"), r) {
      const i = this.createDocumentType("html", r, "");
      this.open(), this.appendChild(i);
    }
  }
  createDocument(s, r, i) {
    return new Zt();
  }
  createDocumentType(s, r, i) {
    const n = new rs(s, r, i);
    return n.ownerDocument = this, n;
  }
  createElement(s) {
    const r = new qt(s);
    return r.ownerDocument = this, r;
  }
  createElementNS(s, r) {
    return this.createElement(r);
  }
  createTextNode(s) {
    const r = new is(s);
    return r.ownerDocument = this, r;
  }
  createComment(s) {
    const r = new ns(s);
    return r.ownerDocument = this, r;
  }
  createCDATASection(s) {
    const r = new os(s);
    return r.ownerDocument = this, r;
  }
  toString() {
    return "RRDocument";
  }
}
class rs extends A {
  constructor(s, r, i) {
    super();
    c(this, "nodeType", 10);
    c(this, "RRNodeType", d.DocumentType);
    c(this, "name");
    c(this, "publicId");
    c(this, "systemId");
    c(this, "textContent", null);
    this.name = s, this.publicId = r, this.systemId = i, this.nodeName = s;
  }
  toString() {
    return "RRDocumentType";
  }
}
class qt extends A {
  constructor(s) {
    super();
    c(this, "nodeType", 1);
    c(this, "RRNodeType", d.Element);
    c(this, "tagName");
    c(this, "attributes", {});
    c(this, "shadowRoot", null);
    c(this, "scrollLeft");
    c(this, "scrollTop");
    this.tagName = s.toUpperCase(), this.nodeName = s.toUpperCase();
  }
  get textContent() {
    let s = "";
    return this.childNodes.forEach((r) => s += r.textContent), s;
  }
  set textContent(s) {
    this.firstChild = null, this.lastChild = null, this.appendChild(this.ownerDocument.createTextNode(s));
  }
  get classList() {
    return new di(
      this.attributes.class,
      (s) => {
        this.attributes.class = s;
      }
    );
  }
  get id() {
    return this.attributes.id || "";
  }
  get className() {
    return this.attributes.class || "";
  }
  get style() {
    const s = this.attributes.style ? li(this.attributes.style) : {}, r = /\B([A-Z])/g;
    return s.setProperty = (i, n, a) => {
      if (r.test(i)) return;
      const o = Lt(i);
      n ? s[o] = n : delete s[o], a === "important" && (s[o] += " !important"), this.attributes.style = be(s);
    }, s.removeProperty = (i) => {
      if (r.test(i)) return "";
      const n = Lt(i), a = s[n] || "";
      return delete s[n], this.attributes.style = be(s), a;
    }, s;
  }
  getAttribute(s) {
    return this.attributes[s] || null;
  }
  setAttribute(s, r) {
    this.attributes[s] = r;
  }
  setAttributeNS(s, r, i) {
    this.setAttribute(r, i);
  }
  removeAttribute(s) {
    delete this.attributes[s];
  }
  appendChild(s) {
    return Kt(this, s);
  }
  insertBefore(s, r) {
    return as(this, s, r);
  }
  removeChild(s) {
    return ls(this, s);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  attachShadow(s) {
    const r = this.ownerDocument.createElement("SHADOWROOT");
    return this.shadowRoot = r, r;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dispatchEvent(s) {
    return !0;
  }
  toString() {
    let s = "";
    for (const r in this.attributes)
      s += `${r}="${this.attributes[r]}" `;
    return `${this.tagName} ${s}`;
  }
}
class fi extends qt {
  constructor() {
    super(...arguments);
    c(this, "currentTime");
    c(this, "volume");
    c(this, "paused");
    c(this, "muted");
    c(this, "playbackRate");
    c(this, "loop");
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  attachShadow(s) {
    throw new Error(
      "RRDomException: Failed to execute 'attachShadow' on 'RRElement': This RRElement does not support attachShadow"
    );
  }
  play() {
    this.paused = !1;
  }
  pause() {
    this.paused = !0;
  }
}
class is extends A {
  constructor(s) {
    super();
    c(this, "nodeType", 3);
    c(this, "nodeName", "#text");
    c(this, "RRNodeType", d.Text);
    c(this, "data");
    this.data = s;
  }
  get textContent() {
    return this.data;
  }
  set textContent(s) {
    this.data = s;
  }
  toString() {
    return `RRText text=${JSON.stringify(this.data)}`;
  }
}
class ns extends A {
  constructor(s) {
    super();
    c(this, "nodeType", 8);
    c(this, "nodeName", "#comment");
    c(this, "RRNodeType", d.Comment);
    c(this, "data");
    this.data = s;
  }
  get textContent() {
    return this.data;
  }
  set textContent(s) {
    this.data = s;
  }
  toString() {
    return `RRComment text=${JSON.stringify(this.data)}`;
  }
}
class os extends A {
  constructor(s) {
    super();
    c(this, "nodeName", "#cdata-section");
    c(this, "nodeType", 4);
    c(this, "RRNodeType", d.CDATA);
    c(this, "data");
    this.data = s;
  }
  get textContent() {
    return this.data;
  }
  set textContent(s) {
    this.data = s;
  }
  toString() {
    return `RRCDATASection data=${JSON.stringify(this.data)}`;
  }
}
class di {
  constructor(t, s) {
    c(this, "onChange");
    c(this, "classes", []);
    c(this, "add", (...t) => {
      for (const s of t) {
        const r = String(s);
        this.classes.indexOf(r) >= 0 || this.classes.push(r);
      }
      this.onChange && this.onChange(this.classes.join(" "));
    });
    c(this, "remove", (...t) => {
      this.classes = this.classes.filter(
        (s) => t.indexOf(s) === -1
      ), this.onChange && this.onChange(this.classes.join(" "));
    });
    if (t) {
      const r = t.trim().split(/\s+/);
      this.classes.push(...r);
    }
    this.onChange = s;
  }
}
function Kt(e, t) {
  return t.parentNode && t.parentNode.removeChild(t), e.lastChild ? (e.lastChild.nextSibling = t, t.previousSibling = e.lastChild) : (e.firstChild = t, t.previousSibling = null), e.lastChild = t, t.nextSibling = null, t.parentNode = e, t.parentElement = e, t.ownerDocument = e.ownerDocument, t;
}
function as(e, t, s) {
  if (!s) return Kt(e, t);
  if (s.parentNode !== e)
    throw new Error(
      "Failed to execute 'insertBefore' on 'RRNode': The RRNode before which the new node is to be inserted is not a child of this RRNode."
    );
  return t === s || (t.parentNode && t.parentNode.removeChild(t), t.previousSibling = s.previousSibling, s.previousSibling = t, t.nextSibling = s, t.previousSibling ? t.previousSibling.nextSibling = t : e.firstChild = t, t.parentElement = e, t.parentNode = e, t.ownerDocument = e.ownerDocument), t;
}
function ls(e, t) {
  if (t.parentNode !== e)
    throw new Error(
      "Failed to execute 'removeChild' on 'RRNode': The RRNode to be removed is not a child of this RRNode."
    );
  return t.previousSibling ? t.previousSibling.nextSibling = t.nextSibling : e.firstChild = t.nextSibling, t.nextSibling ? t.nextSibling.previousSibling = t.previousSibling : e.lastChild = t.previousSibling, t.previousSibling = null, t.nextSibling = null, t.parentElement = null, t.parentNode = null, t;
}
var C = /* @__PURE__ */ ((e) => (e[e.PLACEHOLDER = 0] = "PLACEHOLDER", e[e.ELEMENT_NODE = 1] = "ELEMENT_NODE", e[e.ATTRIBUTE_NODE = 2] = "ATTRIBUTE_NODE", e[e.TEXT_NODE = 3] = "TEXT_NODE", e[e.CDATA_SECTION_NODE = 4] = "CDATA_SECTION_NODE", e[e.ENTITY_REFERENCE_NODE = 5] = "ENTITY_REFERENCE_NODE", e[e.ENTITY_NODE = 6] = "ENTITY_NODE", e[e.PROCESSING_INSTRUCTION_NODE = 7] = "PROCESSING_INSTRUCTION_NODE", e[e.COMMENT_NODE = 8] = "COMMENT_NODE", e[e.DOCUMENT_NODE = 9] = "DOCUMENT_NODE", e[e.DOCUMENT_TYPE_NODE = 10] = "DOCUMENT_TYPE_NODE", e[e.DOCUMENT_FRAGMENT_NODE = 11] = "DOCUMENT_FRAGMENT_NODE", e))(C || {});
const Ft = {
  svg: "http://www.w3.org/2000/svg",
  "xlink:href": "http://www.w3.org/1999/xlink",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, mi = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  fedropshadow: "feDropShadow",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient"
};
let R = null;
function us(e, t, s, r = t.mirror || t.ownerDocument.mirror) {
  e = gi(
    e,
    t,
    s,
    r
  ), cs(e, t, s, r), wi(e, t, s);
}
function gi(e, t, s, r) {
  var i;
  if (s.afterAppend && !R && (R = /* @__PURE__ */ new WeakSet(), setTimeout(() => {
    R = null;
  }, 0)), !Qt(e, t)) {
    const n = Bt(
      t,
      s.mirror,
      r
    );
    (i = e.parentNode) == null || i.replaceChild(n, e), e = n;
  }
  switch (t.RRNodeType) {
    case d.Document: {
      if (!_(e, t, s.mirror, r)) {
        const n = r.getMeta(t);
        n && (s.mirror.removeNodeFromMap(e), e.close(), e.open(), s.mirror.add(e, n), R == null || R.add(e));
      }
      break;
    }
    case d.Element: {
      const n = e, a = t;
      switch (a.tagName) {
        case "IFRAME": {
          const o = e.contentDocument;
          if (!o) break;
          us(
            o,
            t.contentDocument,
            s,
            r
          );
          break;
        }
      }
      a.shadowRoot && (n.shadowRoot || n.attachShadow({ mode: "open" }), cs(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        n.shadowRoot,
        a.shadowRoot,
        s,
        r
      )), yi(n, a, r);
      break;
    }
  }
  return e;
}
function wi(e, t, s) {
  var r;
  switch (t.RRNodeType) {
    case d.Document: {
      const i = t.scrollData;
      i && s.applyScroll(i, !0);
      break;
    }
    case d.Element: {
      const i = e, n = t;
      switch (n.scrollData && s.applyScroll(n.scrollData, !0), n.inputData && s.applyInput(n.inputData), n.tagName) {
        case "AUDIO":
        case "VIDEO": {
          const a = e, o = n;
          o.paused !== void 0 && (o.paused ? a.pause() : a.play()), o.muted !== void 0 && (a.muted = o.muted), o.volume !== void 0 && (a.volume = o.volume), o.currentTime !== void 0 && (a.currentTime = o.currentTime), o.playbackRate !== void 0 && (a.playbackRate = o.playbackRate), o.loop !== void 0 && (a.loop = o.loop);
          break;
        }
        case "CANVAS": {
          const a = t;
          if (a.rr_dataURL !== null) {
            const o = document.createElement("img");
            o.onload = () => {
              const l = i.getContext("2d");
              l && l.drawImage(o, 0, 0, o.width, o.height);
            }, o.src = a.rr_dataURL;
          }
          a.canvasMutations.forEach(
            (o) => s.applyCanvas(
              o.event,
              o.mutation,
              e
            )
          );
          break;
        }
        case "STYLE": {
          const a = i.sheet;
          a && t.rules.forEach(
            (o) => s.applyStyleSheetMutation(o, a)
          );
          break;
        }
      }
      break;
    }
    case d.Text:
    case d.Comment:
    case d.CDATA: {
      e.textContent !== t.data && (e.textContent = t.data);
      break;
    }
  }
  R != null && R.has(e) && (R.delete(e), (r = s.afterAppend) == null || r.call(s, e, s.mirror.getId(e)));
}
function yi(e, t, s) {
  const r = e.attributes, i = t.attributes;
  for (const n in i) {
    const a = i[n], o = s.getMeta(t);
    if (o != null && o.isSVG && Ft[n])
      e.setAttributeNS(Ft[n], n, a);
    else if (t.tagName === "CANVAS" && n === "rr_dataURL") {
      const l = document.createElement("img");
      l.src = a, l.onload = () => {
        const p = e.getContext("2d");
        p && p.drawImage(l, 0, 0, l.width, l.height);
      };
    } else {
      if (t.tagName === "IFRAME" && n === "srcdoc") continue;
      e.setAttribute(n, a);
    }
  }
  for (const { name: n } of Array.from(r))
    n in i || e.removeAttribute(n);
  t.scrollLeft && (e.scrollLeft = t.scrollLeft), t.scrollTop && (e.scrollTop = t.scrollTop);
}
function cs(e, t, s, r) {
  const i = Array.from(e.childNodes), n = t.childNodes;
  if (i.length === 0 && n.length === 0) return;
  let a = 0, o = i.length - 1, l = 0, p = n.length - 1, u = i[a], m = i[o], w = n[l], E = n[p], D, h;
  for (; a <= o && l <= p; )
    if (u === void 0)
      u = i[++a];
    else if (m === void 0)
      m = i[--o];
    else if (
      // same first node?
      _(u, w, s.mirror, r)
    )
      u = i[++a], w = n[++l];
    else if (
      // same last node?
      _(m, E, s.mirror, r)
    )
      m = i[--o], E = n[--p];
    else if (
      // is the first old node the same as the last new node?
      _(u, E, s.mirror, r)
    ) {
      try {
        e.insertBefore(u, m.nextSibling);
      } catch (x) {
        console.warn(x);
      }
      u = i[++a], E = n[--p];
    } else if (
      // is the last old node the same as the first new node?
      _(m, w, s.mirror, r)
    ) {
      try {
        e.insertBefore(m, u);
      } catch (x) {
        console.warn(x);
      }
      m = i[--o], w = n[++l];
    } else {
      if (!D) {
        D = {};
        for (let b = a; b <= o; b++) {
          const M = i[b];
          M && s.mirror.hasNode(M) && (D[s.mirror.getId(M)] = b);
        }
      }
      h = D[r.getId(w)];
      const x = i[h];
      if (h !== void 0 && x && _(x, w, s.mirror, r)) {
        try {
          e.insertBefore(x, u);
        } catch (b) {
          console.warn(b);
        }
        i[h] = void 0;
      } else {
        const b = Bt(
          w,
          s.mirror,
          r
        );
        e.nodeName === "#document" && u && /**
        * Special case 1: one document isn't allowed to have two doctype nodes at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A parent document in the old tree already has a doctype node with an id e.g. #1. A new full snapshot rebuilds the replayer with a new doctype node with another id #2. According to the algorithm, the new doctype node will be inserted before the old one, which is not allowed by the Document standard.
        */
        (b.nodeType === b.DOCUMENT_TYPE_NODE && u.nodeType === u.DOCUMENT_TYPE_NODE || /**
        * Special case 2: one document isn't allowed to have two HTMLElements at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A mounted iframe element has an automatically created HTML element. We should delete it before inserting a serialized one. Otherwise, an error 'Only one element on document allowed' will be thrown.
        */
        b.nodeType === b.ELEMENT_NODE && u.nodeType === u.ELEMENT_NODE) && (e.removeChild(u), s.mirror.removeNodeFromMap(u), u = i[++a]);
        try {
          e.insertBefore(b, u || null);
        } catch (M) {
          console.warn(M);
        }
      }
      w = n[++l];
    }
  if (a > o) {
    const x = n[p + 1];
    let b = null;
    for (x && (b = s.mirror.getNode(
      r.getId(x)
    )); l <= p; ++l) {
      const M = Bt(
        n[l],
        s.mirror,
        r
      );
      try {
        e.insertBefore(M, b);
      } catch (gt) {
        console.warn(gt);
      }
    }
  } else if (l > p)
    for (; a <= o; a++) {
      const x = i[a];
      if (!(!x || x.parentNode !== e))
        try {
          e.removeChild(x), s.mirror.removeNodeFromMap(x);
        } catch (b) {
          console.warn(b);
        }
    }
  let v = e.firstChild, N = t.firstChild;
  for (; v !== null && N !== null; )
    us(v, N, s, r), v = v.nextSibling, N = N.nextSibling;
}
function Bt(e, t, s) {
  const r = s.getId(e), i = s.getMeta(e);
  let n = null;
  if (r > -1 && (n = t.getNode(r)), n !== null && Qt(n, e)) return n;
  switch (e.RRNodeType) {
    case d.Document:
      n = new Document();
      break;
    case d.DocumentType:
      n = document.implementation.createDocumentType(
        e.name,
        e.publicId,
        e.systemId
      );
      break;
    case d.Element: {
      let a = e.tagName.toLowerCase();
      a = mi[a] || a, i && "isSVG" in i && (i != null && i.isSVG) ? n = document.createElementNS(Ft.svg, a) : n = document.createElement(e.tagName);
      break;
    }
    case d.Text:
      n = document.createTextNode(e.data);
      break;
    case d.Comment:
      n = document.createComment(e.data);
      break;
    case d.CDATA:
      n = document.createCDATASection(e.data);
      break;
  }
  i && t.add(n, { ...i });
  try {
    R == null || R.add(n);
  } catch {
  }
  return n;
}
function Qt(e, t) {
  return e.nodeType !== t.nodeType ? !1 : e.nodeType !== e.ELEMENT_NODE || e.tagName.toUpperCase() === t.tagName;
}
function _(e, t, s, r) {
  const i = s.getId(e), n = r.getId(t);
  return i === -1 || i !== n ? !1 : Qt(e, t);
}
class H extends Zt {
  constructor(s) {
    super();
    c(this, "UNSERIALIZED_STARTING_ID", -2);
    // In the rrweb replayer, there are some unserialized nodes like the element that stores the injected style rules.
    // These unserialized nodes may interfere the execution of the diff algorithm.
    // The id of serialized node is larger than 0. So this value less than 0 is used as id for these unserialized nodes.
    c(this, "_unserializedId", this.UNSERIALIZED_STARTING_ID);
    c(this, "mirror", Mi());
    c(this, "scrollData", null);
    s && (this.mirror = s);
  }
  /**
   * Every time the id is used, it will minus 1 automatically to avoid collisions.
   */
  get unserializedId() {
    return this._unserializedId--;
  }
  createDocument(s, r, i) {
    return new H();
  }
  createDocumentType(s, r, i) {
    const n = new bi(
      s,
      r,
      i
    );
    return n.ownerDocument = this, n;
  }
  createElement(s) {
    const r = s.toUpperCase();
    let i;
    switch (r) {
      case "AUDIO":
      case "VIDEO":
        i = new Ei(r);
        break;
      case "IFRAME":
        i = new Ri(r, this.mirror);
        break;
      case "CANVAS":
        i = new xi(r);
        break;
      case "STYLE":
        i = new Ci(r);
        break;
      default:
        i = new mt(r);
        break;
    }
    return i.ownerDocument = this, i;
  }
  createComment(s) {
    const r = new Si(s);
    return r.ownerDocument = this, r;
  }
  createCDATASection(s) {
    const r = new vi(s);
    return r.ownerDocument = this, r;
  }
  createTextNode(s) {
    const r = new Ni(s);
    return r.ownerDocument = this, r;
  }
  destroyTree() {
    this.firstChild = null, this.lastChild = null, this.mirror.reset();
  }
  open() {
    super.open(), this._unserializedId = this.UNSERIALIZED_STARTING_ID;
  }
}
const bi = rs;
class mt extends qt {
  constructor() {
    super(...arguments);
    c(this, "inputData", null);
    c(this, "scrollData", null);
  }
}
class Ei extends fi {
}
class xi extends mt {
  constructor() {
    super(...arguments);
    c(this, "rr_dataURL", null);
    c(this, "canvasMutations", []);
  }
  /**
   * This is a dummy implementation to distinguish RRCanvasElement from real HTMLCanvasElement.
   */
  getContext() {
    return null;
  }
}
class Ci extends mt {
  constructor() {
    super(...arguments);
    c(this, "rules", []);
  }
}
class Ri extends mt {
  constructor(s, r) {
    super(s);
    c(this, "contentDocument", new H());
    this.contentDocument.mirror = r;
  }
}
const Ni = is, Si = ns, vi = os;
function Oi(e) {
  return e instanceof HTMLFormElement ? "FORM" : e.tagName.toUpperCase();
}
function Di(e, t, s, r) {
  let i;
  switch (e.nodeType) {
    case C.DOCUMENT_NODE:
      r && r.nodeName === "IFRAME" ? i = r.contentDocument : (i = t, i.compatMode = e.compatMode);
      break;
    case C.DOCUMENT_TYPE_NODE: {
      const a = e;
      i = t.createDocumentType(
        a.name,
        a.publicId,
        a.systemId
      );
      break;
    }
    case C.ELEMENT_NODE: {
      const a = e, o = Oi(a);
      i = t.createElement(o);
      const l = i;
      for (const { name: p, value: u } of Array.from(a.attributes))
        l.attributes[p] = u;
      a.scrollLeft && (l.scrollLeft = a.scrollLeft), a.scrollTop && (l.scrollTop = a.scrollTop);
      break;
    }
    case C.TEXT_NODE:
      i = t.createTextNode(e.textContent || "");
      break;
    case C.CDATA_SECTION_NODE:
      i = t.createCDATASection(e.data);
      break;
    case C.COMMENT_NODE:
      i = t.createComment(e.textContent || "");
      break;
    case C.DOCUMENT_FRAGMENT_NODE:
      i = r.attachShadow({ mode: "open" });
      break;
    default:
      return null;
  }
  let n = s.getMeta(e);
  return t instanceof H && (n || (n = Ai(i, t.unserializedId), s.add(e, n)), t.mirror.add(i, { ...n })), i;
}
function Ii(e, t = ws(), s = new H()) {
  function r(i, n) {
    const a = Di(i, s, t, n);
    if (a !== null)
      if (
        // if the parentRRNode isn't a RRIFrameElement
        (n == null ? void 0 : n.nodeName) !== "IFRAME" && // if node isn't a shadow root
        i.nodeType !== C.DOCUMENT_FRAGMENT_NODE && (n == null || n.appendChild(a), a.parentNode = n, a.parentElement = n), i.nodeName === "IFRAME"
      ) {
        const o = i.contentDocument;
        o && r(o, a);
      } else (i.nodeType === C.DOCUMENT_NODE || i.nodeType === C.ELEMENT_NODE || i.nodeType === C.DOCUMENT_FRAGMENT_NODE) && (i.nodeType === C.ELEMENT_NODE && i.shadowRoot && r(i.shadowRoot, a), i.childNodes.forEach((o) => r(o, a)));
  }
  return r(e, null), s;
}
function Mi() {
  return new ki();
}
class ki {
  constructor() {
    c(this, "idNodeMap", /* @__PURE__ */ new Map());
    c(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    var r;
    return t ? ((r = this.getMeta(t)) == null ? void 0 : r.id) ?? -1 : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const s = this.getId(t);
    this.idNodeMap.delete(s), t.childNodes && t.childNodes.forEach((r) => this.removeNodeFromMap(r));
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, s) {
    const r = s.id;
    this.idNodeMap.set(r, t), this.nodeMetaMap.set(t, s);
  }
  replace(t, s) {
    const r = this.getNode(t);
    if (r) {
      const i = this.nodeMetaMap.get(r);
      i && this.nodeMetaMap.set(s, i);
    }
    this.idNodeMap.set(t, s);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function Ai(e, t) {
  switch (e.RRNodeType) {
    case d.Document:
      return {
        id: t,
        type: e.RRNodeType,
        childNodes: []
      };
    case d.DocumentType: {
      const s = e;
      return {
        id: t,
        type: e.RRNodeType,
        name: s.name,
        publicId: s.publicId,
        systemId: s.systemId
      };
    }
    case d.Element:
      return {
        id: t,
        type: e.RRNodeType,
        tagName: e.tagName.toLowerCase(),
        // In rrweb data, all tagNames are lowercase.
        attributes: {},
        childNodes: []
      };
    case d.Text:
      return {
        id: t,
        type: e.RRNodeType,
        textContent: e.textContent || ""
      };
    case d.Comment:
      return {
        id: t,
        type: e.RRNodeType,
        textContent: e.textContent || ""
      };
    case d.CDATA:
      return {
        id: t,
        type: e.RRNodeType,
        textContent: ""
      };
  }
}
function _i(e, t) {
  return nt(e, t, "");
}
function nt(e, t, s) {
  let r = `${s}${t.getId(e)} ${e.toString()}
`;
  if (e.RRNodeType === d.Element) {
    const i = e;
    i.shadowRoot && (r += nt(i.shadowRoot, t, s + "  "));
  }
  for (const i of e.childNodes)
    r += nt(i, t, s + "  ");
  return e.nodeName === "IFRAME" && (r += nt(
    e.contentDocument,
    t,
    s + "  "
  )), r;
}
export {
  os as BaseRRCDATASection,
  ns as BaseRRComment,
  Zt as BaseRRDocument,
  rs as BaseRRDocumentType,
  qt as BaseRRElement,
  fi as BaseRRMediaElement,
  A as BaseRRNode,
  is as BaseRRText,
  di as ClassList,
  ki as Mirror,
  C as NodeType,
  vi as RRCDATASection,
  xi as RRCanvasElement,
  Si as RRComment,
  H as RRDocument,
  bi as RRDocumentType,
  mt as RRElement,
  Ri as RRIFrameElement,
  Ei as RRMediaElement,
  A as RRNode,
  Ci as RRStyleElement,
  Ni as RRText,
  Ii as buildFromDom,
  Di as buildFromNode,
  Mi as createMirror,
  Bt as createOrGetNode,
  us as diff,
  Ai as getDefaultSN,
  _i as printRRDom
};
//# sourceMappingURL=rrdom.js.map
